export enum CreditCardKeys {
  Visa = 'VISA',
  Mastercard = 'MASTERCARD',
  AMEX = 'AMERICAN_EXPRESS',
  Discover = 'DISCOVER',
}

export enum CreditCartTypes {
  Visa = 'Visa',
  Mastercard = 'MasterCard',
  AMEX = 'American_Express',
  Discover = 'Discover',
  AmericanExpress = 'AmericanExpress',
}
